/* eslint-disable no-console */
import { FormInstance } from 'antd'
import Cookie from 'js-cookie'
import { NextRouter } from 'next/router'
import { ct_sid_name, ct_vid_name, User } from '../models'

export const hasWrongToken = async (token: string): Promise<boolean> => {
  try {
    const isValidToken = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/token-verify/?token=${token}`)
      .then( response => response.status ===  400)
    return isValidToken
  } catch (error) {
    return false
  }
}

export const deleteAllCookies = () => {
  Object.keys(Cookie.get()).forEach(function (cookieName) {
    if (![ct_vid_name, ct_sid_name].includes(cookieName)) {
      Cookie.remove(cookieName, {
        domain: process.env.CT_DOMAIN,
        path: '/',
      })
      Cookie.remove(cookieName,  {
        domain: process.env.MARKET_PLACE_URL.replace('https://', ''),
        path: '/'
      })
    }
  })
}

export const removeToken = () => {
  try {
    if (typeof window !== 'undefined') {
      localStorage?.removeItem(process.env.NEXT_PUBLIC_TOKEN_NAME)
    }
    Cookie.remove(process.env.NEXT_PUBLIC_TOKEN_NAME,  { domain: process.env.CT_DOMAIN, path: '/' })
    Cookie.remove(process.env.NEXT_PUBLIC_TOKEN_NAME,  { domain: process.env.MARKET_PLACE_URL.replace('https://', ''), path: '/' })
  } catch (error) {
    return
  }
}

export const forgotPassword = () => {
  removeToken()
  window.location.href = `/accounts/auth/forgot-password`
}

export const logout = (router: NextRouter = null) => {
  removeToken()
  if (router) { router.push('/auth/login') }
  else { window.location.href = `/accounts/auth/login` }
}


export const isNotAuthRequest = (url: string) => {
  const urls = [
    'big_register', 'request_restore_code', 'restore_password', 'update_details','algonode',
    'token-auth', 'token-verify', 'tracking', 'visitors', 'verify_email', 'complete_user_info'
  ]
  for (const u of urls) { if (url.includes(u)) return false }
  return true
}

export const isOtherAPI = (url: string) => {
  const urls = ['calculator', 'tracking']
  for (const u of urls) { if (url.includes(u)) return true }
  return false
}

export const handleLoginSuccess = (
  rememberMe: boolean, form: FormInstance,
  router: NextRouter, redirect: string | string[],
  user: User
) => {
  const marketUrl = process.env.MARKET_PLACE_URL

  // Check Remember me email
  if (rememberMe) {
    localStorage.setItem(
      'credentials',
      JSON.stringify({ email: form.getFieldValue('email') })
    )
  }

  // Check Checkout market url
  const { ft_enableNewCheckout } = router.query
  if (['true', 'false'].includes(String(ft_enableNewCheckout))) {
    localStorage.setItem('enable-new-checkout', String(ft_enableNewCheckout))
  }

  // Check that redirection is to another page (Portal-Developers for example)
  if (redirect && window && typeof redirect === 'string' ) {
    window.location.href = redirect
    return
  }

  // Check Home Accounts Url
  const prevRoute = localStorage.getItem('prevRoute')
  if (!(prevRoute && prevRoute !== '/accounts/')) {
    router.push('/')
    localStorage.removeItem('prevRoute')
    return
  }

  // Check urls like market, project-details and home
  if (!prevRoute?.startsWith('/accounts')) {
    window.location.href = `${marketUrl}${prevRoute}`
    localStorage.removeItem('prevRoute')
    return
  }

  // Check accounts urls
  const prevRouteAux = prevRoute?.substring(9, prevRoute.length)
  const url = getValidatedPrevRoute(prevRouteAux, user)
  router.push(url)
  localStorage.removeItem('prevRoute')
}

export const getValidatedPrevRoute = (route: string, user: User): string => {
  const widget = ['/developers', '/stock-alerts']
  const producerUrls = ['/my-sales', '/my-projects']
  const prevRoute = localStorage.getItem('prevRoute')

  if (!prevRoute || !user) return route

  // Validate Admin Routes
  if (route.includes('/admin') && !user.is_superuser) return '/summary'

  // Validate Widget Routes
  if (widget.some(r => route.includes(r)) && !user.is_widget) return '/summary'

  // Validate Producer Routes
  const userIsNotProjectDeveloper = !user.is_project_developer && !user.is_superuser
  if (producerUrls.some(r => route.includes(r)) && userIsNotProjectDeveloper) return '/summary'
  return route
}


export const mustRefreshTheToken = (token: string): boolean => {
  const tokenPayload = JSON.parse(atob(token.split('.')[1]))
  const expirationDate = new Date(tokenPayload.exp * 1000)
  const currentDate = new Date()
  // Calculate the difference between the expiration date and the current date
  const timeDiff = expirationDate.getTime() - currentDate.getTime()
  // Convert the time difference from milliseconds to minutes
  const timeLeftInMinutes = Math.floor(timeDiff / (1000 * 60))
  // Check if the token has less than 10 minutes left
  return timeLeftInMinutes <= 10
}

export const updateAuthCookiesAndLocalStorage = (newToken: string) => {
  // Delete all Cookies and LocalStorage
  removeToken()
  // Set New Token on Cookies and LocalStorage
  const tokenName = process.env.NEXT_PUBLIC_TOKEN_NAME
  localStorage.setItem(tokenName, newToken)
  Cookie.set(process.env.NEXT_PUBLIC_TOKEN_NAME, newToken, {
    domain: process.env.CT_DOMAIN,
    path: '/',
    expires: new Date(Date.now() + 3600000)
  })
}
